'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var studyStar = function studyStar() {
  return import('@/page/studyStar/studyStar');
};
var studyStarList = function studyStarList() {
  return import('@/page/studyStar');
};
var studyStarDetail = function studyStarDetail() {
  return import('@/page/studyStar/detail');
};
exports.default = [{
  path: '/studyStar',
  name: 'studyStar',
  component: studyStar,
  children: [{
    path: '/studyStarList',
    name: 'studyStarList',
    component: studyStarList
  }, {
    path: '/studyStarDetail',
    name: 'studyStarDetail',
    component: studyStarDetail
  }]
}];